import PropTypes from 'prop-types';
export const whyTrustUsPropTypes = {
  /**
   * Main content of tooltip
   */
  text: PropTypes.string,
  /**
   * The text to display in tooltip footer
   */
  footerText: PropTypes.string
};